// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hWyy","type":"styles_type__21Fdw","choices":"styles_choices__ZxOJY"};